import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

const NotFound: FC = () => {

    return (
        <div className="m-3">
            Страница не найдена
        </div>
    )
};
export default observer(NotFound);